// extracted by mini-css-extract-plugin
export var searchHeader = "_7c-0";
export var searchHeaderDark = "_7c-1";